import NavbarMobile from './NavbarMobile'
import NavbarDesktop from './NavbarDesktop'

const DesktopNavbar = ({showMobileNav, toggleSidenav}) => (
	showMobileNav ? <NavbarMobile toggleSidenav={toggleSidenav} /> : <NavbarDesktop />
	// showMobileNav ? <NavbarMobile toggleSidenav={toggleSidenav} /> : <div />
)

export default DesktopNavbar;